import { render, staticRenderFns } from "./requestSMSnoti.vue?vue&type=template&id=d107297c&scoped=true"
import script from "./requestSMSnoti.vue?vue&type=script&lang=js"
export * from "./requestSMSnoti.vue?vue&type=script&lang=js"
import style0 from "./requestSMSnoti.vue?vue&type=style&index=0&id=d107297c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d107297c",
  null
  
)

export default component.exports